module.exports = __webpack_public_path__ + "img/screens-single.5f701c3b.svg";